<template>
  <div class="notfound-container">
    <div class="notfound-orb notfound-orb-1"></div>
    <div class="notfound-orb notfound-orb-2"></div>

    <div class="notfound-card">
      <div class="notfound-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>

      <div class="notfound-code">404</div>
      <h1 class="notfound-title">Page not found</h1>
      <p class="notfound-desc">
        The page you're looking for doesn't exist or has been moved.
        Let's get you back on track.
      </p>

      <div class="notfound-actions">
        <button class="notfound-btn notfound-btn-primary" @click="goHome">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          Go Home
        </button>
        <button class="notfound-btn notfound-btn-secondary" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
          Go Back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.push('/');
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    }
  }
};
</script>

<style scoped>
.notfound-container {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
  padding: 24px;
  overflow: hidden;
}

.notfound-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.5;
  pointer-events: none;
}

.notfound-orb-1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, #3b82f6, transparent);
  top: -120px;
  left: -120px;
  animation: notfound-float 8s ease-in-out infinite;
}

.notfound-orb-2 {
  width: 360px;
  height: 360px;
  background: radial-gradient(circle, #8b5cf6, transparent);
  bottom: -100px;
  right: -100px;
  animation: notfound-float 10s ease-in-out infinite reverse;
}

@keyframes notfound-float {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(30px, -30px); }
}

.notfound-card {
  position: relative;
  z-index: 1;
  max-width: 480px;
  width: 100%;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 48px 40px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: notfound-fade-in 0.5s ease-out;
}

@keyframes notfound-fade-in {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

.notfound-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(139, 92, 246, 0.2));
  color: #60a5fa;
  border: 1px solid rgba(96, 165, 250, 0.3);
}

.notfound-code {
  font-size: 72px;
  font-weight: 700;
  letter-spacing: -2px;
  background: linear-gradient(135deg, #60a5fa, #a78bfa);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1;
  margin-bottom: 8px;
}

.notfound-title {
  font-size: 24px;
  font-weight: 600;
  color: #f1f5f9;
  margin: 0 0 12px;
}

.notfound-desc {
  font-size: 15px;
  line-height: 1.6;
  color: #94a3b8;
  margin: 0 0 32px;
}

.notfound-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.notfound-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 22px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.notfound-btn-primary {
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  color: #fff;
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);
}

.notfound-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.45);
}

.notfound-btn-secondary {
  background: rgba(255, 255, 255, 0.06);
  color: #e2e8f0;
  border-color: rgba(255, 255, 255, 0.12);
}

.notfound-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

@media (max-width: 480px) {
  .notfound-card { padding: 36px 24px; }
  .notfound-code { font-size: 60px; }
  .notfound-title { font-size: 20px; }
  .notfound-actions { flex-direction: column; }
  .notfound-btn { width: 100%; justify-content: center; }
}
</style>
